import i18n from "./i18n";

export function euro(
  n: number | null | undefined,
  opts?: { compact?: boolean },
): string {
  if (n == null) return "—";
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
    notation: opts?.compact ? "compact" : "standard",
  }).format(n);
}

/**
 * Localized "x ago" using Intl.RelativeTimeFormat in the active i18n language.
 * Reads `i18n` directly (not a hook) so it stays a plain formatter; callers are
 * components using `useTranslation`, so they re-render — and re-run this — on a
 * language switch.
 */
export function relativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "—";
  const lang = i18n.resolvedLanguage || i18n.language || "nl";
  const mins = Math.round((then - Date.now()) / 60_000); // negative = past
  if (Math.abs(mins) < 1) return i18n.t("time.justNow");
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: "auto", style: "short" });
  if (Math.abs(mins) < 60) return rtf.format(mins, "minute");
  const hrs = Math.round(mins / 60);
  if (Math.abs(hrs) < 24) return rtf.format(hrs, "hour");
  const days = Math.round(hrs / 24);
  if (Math.abs(days) < 30) return rtf.format(days, "day");
  const months = Math.round(days / 30);
  return rtf.format(months, "month");
}

export function initials(name: string): string {
  const parts = name.split(/\s+/).filter(Boolean).slice(0, 2);
  return parts.map((p) => (p[0] ?? "").toUpperCase()).join("") || "?";
}
